import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'materialize-css/dist/css/materialize.css'
import 'materialize-css/dist/js/materialize.js'


Vue.config.productionTip = false

import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage);

require('./assets/css/main.scss')

import InfoSectionComponent from './components/InfoSectionComponent'
Vue.component('info-section', InfoSectionComponent);

import FooterComponent from './components/FooterComponent'
Vue.component('footer-sb', FooterComponent);

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
